module.exports = __webpack_public_path__ + "static/media/Group3.3aa26497.png";